<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="$t('WriteOff.modifyMatchStatus')"
    width="400px"
    @close="handleClose"
  >
    <el-form label-width="100px" label-position="left">
      <el-form-item :label="$t('WriteOff.modifyStatus')">
        <el-select v-model="form.writeoffMatchStatus" :placeholder="$t('WriteOff.modifyStatus')" style="width: 100%">
          <el-option :label="$t('WriteOff.matchStatusManual')" :value="2" />
          <el-option :label="$t('WriteOff.matchStatusNoNeed')" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('WriteOff.modifyReason')">
        <el-input v-model="form.writeoffMatchStatusReason" type="textarea" :rows="3" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">{{ $t('common.btn.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('WriteOff.confirmModify') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { modifyWriteoffMatchStatus } from '@/api/clearing/actualAmount'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'ModifyMatchStatusDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        writeoffMatchStatus: 2,
        writeoffMatchStatusReason: ''
      }
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.writeoffMatchStatus = 2
        this.form.writeoffMatchStatusReason = ''
      }
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    async handleConfirm() {
      const rows = this.selectedRows
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('WriteOff.selectAtLeastOne'))
        return
      }

      // 前置校验
      const hasLocked = rows.some(r => r.writeoffMatchStatus === 1)
      const hasModifiable = rows.some(r => r.writeoffMatchStatus === 0 || r.writeoffMatchStatus === 2 || r.writeoffMatchStatus === 3)

      if (hasLocked && hasModifiable) {
        this.$message.warning(this.$t('WriteOff.containsLockedStatus'))
        return
      }
      if (hasLocked) {
        this.$message.warning(this.$t('WriteOff.lockedCannotModify'))
        return
      }

      // 校验是否为导入数据
      const hasNonImport = rows.some(r => !r.importData)
      if (hasNonImport) {
        this.$message.warning(this.$t('WriteOff.pleaseSelectUnmatched'))
        return
      }

      const loading = getLoading()
      const uuids = rows.map(r => r.uuid)
      try {
        const res = await modifyWriteoffMatchStatus({
          uuids: uuids,
          writeoffMatchStatus: this.form.writeoffMatchStatus,
          writeoffMatchStatusReason: this.form.writeoffMatchStatusReason
        })
        if (res && res.data !== undefined) {
          const count = res.data
          this.$message.success(
            this.$t('WriteOff.modifySuccess').replace('{0}', count)
          )
          this.dialogVisible = false
          this.$emit('confirmSuccess')
        }
      } catch (e) {
        // error handled by global interceptor
      } finally {
        loading.close()
      }
    }
  }
}
</script>
